import { Component, OnInit } from '@angular/core';
import {SessionService} from "../../../session/session.service";

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  constructor(private _session: SessionService) { }

  ngOnInit(): void {
  }

  /** Mismo dato que usa LoginGuard (`ifNotActivated`) para mandar aquí a quien CNC aún no ha activado. */
  get activado(): boolean {
    return this._session.token.isEnabled();
  }

}
